<template>
  <el-collapse v-model="activeNames" accordion>
    <el-collapse-item title="Настройки" name="settings">
      <el-form ref="postInfoForm" :model="postInfo" label-width="120px" label-position="top">
        <el-form-item label="Ссылка на пост">
          <el-input :value="post.uri" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="Возраст от">
          <el-input v-model="postInfo.age_from"></el-input>
        </el-form-item>
        <el-form-item label="Возраст до">
          <el-input v-model="postInfo.age_to"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getPostInfo">Анализировать</el-button>
        </el-form-item>
      </el-form>
    </el-collapse-item>

    <el-collapse-item :title="`Анализ | возраст ${age_from} - ${age_to}`" name="analysis" v-loading="loading">
      <table class="table-post-info" width="100%" v-if="!loading">
        <tr class="table-head">
          <td class="table-head-column"></td>
          <th class="table-head-column"><i class="fas fa-male"></i></th>
          <th class="table-head-column"><i class="fas fa-female"></i></th>
          <th class="table-head-column"><i class="fas fa-question"></i></th>
          <th class="table-head-column">Итого</th>
        </tr>
        <tr class="table-row">
          <td class="table-row--title">Лайк</td>
          <td>{{this.gridData.likes.m}}</td>
          <td>{{this.gridData.likes.w}}</td>
          <td>{{this.gridData.likes.u}}</td>
          <td>{{this.gridData.likes.m + this.gridData.likes.w + this.gridData.likes.u}}</td>
        </tr>
        <tr class="table-row">
          <td class="table-row--title">Репост</td>
          <td>{{this.gridData.reposts.m}}</td>
          <td>{{this.gridData.reposts.w}}</td>
          <td>{{this.gridData.reposts.u}}</td>
          <td>{{this.gridData.reposts.m + this.gridData.reposts.w + this.gridData.reposts.u}}</td>
        </tr>
        <tr class="table-row">
          <td class="table-row--title">Комментарий</td>
          <td>{{this.gridData.commentaries.m}}</td>
          <td>{{this.gridData.commentaries.w}}</td>
          <td>{{this.gridData.commentaries.u}}</td>
          <td>{{this.gridData.commentaries.m + this.gridData.commentaries.w + this.gridData.commentaries.u}}</td>
        </tr>
      </table>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
  // api
  import { getPostInfoApi } from "../../../../../../../api/publications";

  export default {
    name: "PostInfo",
    props: {
      post: {
        type: Object
      },
      gridData: {
        type: Object
      },
      loading: {
        type: Boolean
      },
      postInfo: {
        age_from: {
        type: Number
        },
        age_to: {
        type: Number
        },
      },
      age_from: {
        type: Number
        },
        age_to: {
        type: Number
        },
    },
    data() {
      return {
        loading: false,
        activeNames: 'analysis',
        age_from: '',
        age_to: '',
        postInfo: {
          age_from: 32,
          age_to: 52,
        },
        gridData: {
          likes: {},
          reposts: {},
          commentaries: {},
        },
      };
    },
    methods: {
      getPostInfo() {
        this.age_from = this.postInfo.age_from;
        this.age_to = this.postInfo.age_to;

        this.activeNames = 'analysis';
        this.loading = true;

        let params = {
          post_link: this.post.uri,
          age_from: this.postInfo.age_from,
          age_to: this.postInfo.age_to,
        };

        getPostInfoApi(params).then(resp => {
          this.gridData = {...this.gridData, ...resp.data};
          this.loading = false;
        });
      },
      onSubmit() {
        this.activeNames = 'analysis';
      },
    },
    mounted() {
      //this.getPostInfo();
    }
  };
</script>

<style>
  .table-post-info {
    width: 100%;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    line-height: 14px;
    border-collapse:collapse;
  }
  .table-head-column{
    padding-bottom: 10px;
    border-bottom: 1px solid #E4E7ED;
  }
  .table-row td, .table-head td {
    text-align: center;
    padding-top: 10px;
  }
  .table-row .table-row--title{
    text-align: left;
  }
</style>
